import React from 'react';
import {Skeleton, Box} from '@customink/pigment-react';

export default function ComplementCardSkeleton() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        maxWidth: '220px',
        border: '1px solid',
        borderColor: 'grey.200',
        borderRadius: 1,
        mb: 2,
        backgroundColor: 'background.paper',
        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
        transition: 'box-shadow 0.3s ease'
      }}>
      <Skeleton
        variant="rectangular"
        width="100%"
        height={160}
        sx={{
          mb: 2,
          animation: 'pulse 1.5s ease-in-out infinite',
          '@keyframes pulse': {
            '0%': {
              opacity: 1
            },
            '50%': {
              opacity: 0.5
            },
            '100%': {
              opacity: 1
            }
          }
        }}
      />
      <Box sx={{p: 2}}>
        <Skeleton
          variant="text"
          width="70%"
          height={24}
          sx={{
            mb: 1,
            animation: 'pulse 1.5s ease-in-out 0.2s infinite'
          }}
        />
        <Skeleton
          variant="text"
          width="40%"
          height={20}
          sx={{
            animation: 'pulse 1.5s ease-in-out 0.4s infinite'
          }}
        />
      </Box>
    </Box>
  );
}
